const styles = {
  textAlign: 'center'
};

export const supplierDataChangeColumns = (t, lang) => {
  return [
    {
      Header: '№',
      width: 60,
      style: styles,
      Cell: row => row.index + 1
    },
    {
      Header: 'ID',
      accessor: 'id',
      width: 80,
      style: styles
    },
    {
      Header: t('supplierDataChange_columnBin'),
      accessor: 'bin',
      width: 160,
      style: styles
    },
    {
      Header: t('supplierDataChange_columnName'),
      accessor: `${lang}_name`,
      style: styles,
      Cell: ({ original }) => original[`${lang}_name`]
    },
    {
      Header: t('supplierDataChange_columnIin'),
      accessor: 'iin',
      width: 160,
      style: styles
    },
    {
      Header: t('supplierDataChange_columnLocation'),
      accessor: 'location',
      style: styles,
      Cell: ({ original }) =>
        original.providerLocation ? original.providerLocation[`${lang}_name`] : ''
    }
  ];
};
